import React, { ReactNode } from 'react'
import cn from 'classnames'
import styled from 'styled-components'

import { AlertIcon } from '../../lib/icons/alert-icon'
import { InfoIcon } from '../../lib/icons/info-icon'

export enum AlertType {
    Info,
    Warning,
    Error,
}

const SInlineAlert = styled.div`
    border: 1px solid transparent;
    border-radius: 4px;
    color: black;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.sizing.margin.m};
    margin-top: ${({ theme }) => theme.sizing.padding.l};
    margin-bottom: ${({ theme }) => theme.sizing.padding.l};
    overflow: hidden;

    .icon {
        margin-right: ${({ theme }) => theme.sizing.margin.l};
        padding: ${({ theme }) => theme.sizing.padding.m};
    }

    @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm}) {
        flex-wrap: wrap;

        .icon {
            width: 100%;
            margin-right: unset;
        }

        #inline-alert-text {
            margin-left: ${({ theme }) => theme.sizing.margin.s};
            margin-right: ${({ theme }) => theme.sizing.margin.s};
        }

        #inline-alert-btn {
            width: 100%;

            button {
                width: inherit;
            }
        }
    }

    &.error {
        background-color: ${({ theme }) => theme.font.errorColor + '0a'};
        .icon {
            background-color: ${({ theme }) => theme.font.errorColor};
        }
    }

    &.warning {
        background-color: ${({ theme }) => theme.font.warningColor + '0a'};
        .icon {
            background-color: ${({ theme }) => theme.font.warningColor};
        }
    }
    &.info {
        background-color: ${({ theme }) => theme.font.infoColor + '2a'};
        .icon {
            background-color: ${({ theme }) => theme.font.infoColor};
        }
    }
`

interface IComponentProps {
    text: string
    alertType: AlertType
    'data-testid': string
    actionBtn?: ReactNode
}

const InlineAlert = ({ text, alertType = AlertType.Info, actionBtn, ...props }: IComponentProps) => {
    return (
        <SInlineAlert
            className={cn({
                warning: alertType === AlertType.Warning,
                error: alertType === AlertType.Error,
                info: alertType === AlertType.Info,
            })}
            {...props}
        >
            <div className="icon">
                {alertType === AlertType.Info ? (
                    <InfoIcon size={20} fill="white" />
                ) : (
                    <AlertIcon size={25} fill="white" />
                )}
            </div>
            <span data-testid="inline-alert-text" id="inline-alert-text">
                {text}
            </span>
            {actionBtn && (
                <span
                    data-testid="inline-alert-btn"
                    className="ml-auto flex flex-shrink-0 align-items-center justify-content-end p-2"
                    id="inline-alert-btn"
                >
                    {actionBtn}
                </span>
            )}
        </SInlineAlert>
    )
}

export default InlineAlert
